<template>
  <div v-wechat-title="titleTop">
    <div class="topBar">
      <TopBar :pagetitle="title" :back-url="backurl" />
    </div>

    <div class="topRect">
      <img src="/grouptest/xmas2019socks_sky.png">
    </div>
    <div class="bottonRect">
      <img src="/grouptest/xmas2019socks_land.png">
    </div>
    <div class="box">
      <img src="/grouptest/xmas2019socks_box.png">
    </div>
    <div class="downButton">
      <van-button style="width:60%;left:20%;" round :color="GetColorMain()" @click="showShare=true">转赠礼物</van-button>
    </div>

    <let-it-snow
      v-bind="starConf"
      :show="show"
    />
    <wxShare v-model="showShare" :title="shareTitle" :desc="shareAbout" :timeline="shareTimeline" :url="shareUrl" :img="shareIcon" @onFinish="onShareFinish" />
  </div>
</template>
<script>
import { Button, Overlay, Dialog } from 'vant'
import TopBar from '@/components/TopBar'
import { getUrlKey, GetColorMainBack, GetColorMain, GetColorSecondary, GetSysTitle, GetColorMainLine } from '@/utils/base'
import wxShare from '@/components/wxShare'
import { GetSelfUrl } from '@/utils/request'
import LetItSnow from 'vue-let-it-snow'
export default {
  components: {
    [Dialog.name]: Dialog,
    [Button.name]: Button,
    [Overlay.name]: Overlay,
    TopBar,
    wxShare,
    LetItSnow
  },
  inject: ['reload'],
  data() {
    return {
      key: undefined,
      id: undefined,
      icon: undefined,
      system: undefined,
      titleTop: '',
      title: '转赠礼物',
      backurl: '/store/index',
      showShare: false,
      shareTitle: '',
      shareAbout: '',
      shareTimeline: '',
      shareUrl: '',
      shareIcon: '',
      starConf: {
        windPower: 0,
        speed: 0.2,
        count: 20,
        size: 10,
        opacity: 1,
        images: ['/grouptest/box0.png']
      },
      show: false
    }
  },

  created() {
    this.key = this.$route.params.key
    this.id = getUrlKey('id')
    this.icon = getUrlKey('icon')
    this.system = getUrlKey('system')
    console.log(this.icon)
    setTimeout(() => {
      this.show = true
    }, 10)
    setTimeout(() => {
      this.initShare()
    }, 2000)
  },
  methods: {
    GetColorMainLine,
    GetColorMainBack,
    GetColorMain,
    GetColorSecondary,
    GetSysTitle,
    onShareFinish() {
      this.shareUrl = undefined
    },
    initShare() {
      this.shareTitle = '送你一个潜水员惊喜礼物!'
      this.shareAbout = '点击你的圣诞袜，收下这份转赠礼物吧！'
      this.shareTimeline = '我正在转赠我的礼物！你的圣诞惊喜礼物领了吗？'
      this.shareIcon = 'https://m.diveboss.net/grouptest/xmas20192icon.jpg'// this.icon
      this.shareUrl = GetSelfUrl() + 'group/giftBox/' + this.key + '?id=' + this.id + '&system=' + this.system
      console.log('this.shareUrl', this.shareUrl)
      this.showShare = true
    }
  }
}
</script>
<style scoped>
.topBar{
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 3em;
  z-index: 100000;
}
.topRect{
    background-color: #13334C;
    height: 40em;
    margin-top: 3em;
}
.topRect img{
    width: 100%;
    display: block;
}
.bottonRect{
    position: absolute;
    top: 30em;
    z-index: 100000;
}
.bottonRect img{
    width: 100%;
    display: block;
}
.box{
  position: absolute;
  top: 28em;
  z-index: 100001;
  text-align: center;
  width: 100%;
  text-align: center;
}
.box img{
  width: 30%;
}
.downButton{
  position: fixed;
  bottom: 1em;
  width: 100%;
  z-index: 100001;
}
</style>
